module.exports = __webpack_public_path__ + "img/event_example.4fd77f06.png";